import React from 'react';

import { getService } from '../shell';

interface Transformation {
  [key: string]: any;
  height?: string;
  width?: string;
  dpr?: string;
  crop?: string;
  default_image?: string;
}

export interface ClImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  publicId: string;
  transformation?: Transformation;
}

export const ClImage: React.FC<ClImageProps> = ({
  publicId,
  transformation,
  ...rest
}) => {
  return (
    <img
      {...rest}
      src={getCloudinarySrc({
        publicId,
        transformation,
      })}
    />
  );
};

function getCloudinarySrc({
  publicId,
  transformation,
}: {
  publicId?: string;
  transformation?: Transformation;
}): string {
  const cloudinary = getService('cloudinary');

  return cloudinary.url(publicId, {
    transformation,
  });
}
